<template>
  <v-overlay :value="dialog" color="overlayColor" opacity="0.95">
    <v-container @keydown.enter="confirm">
      <v-row class="pa-10 text-center">
        <div v-if="error" class="col-sm-1 col-md-3"></div>
        <div v-if="error" class="col-sm-10 col-md-6">
          <v-alert class="mt-5 red" border="left" text>
            {{ errorMsg }}
          </v-alert>
        </div>
        <div class="col-12 white--text"></div>
        <div class="col-md-12 col-sm-12">
          <v-textarea
            id="custom-input"
            v-model="commentText"
            auto-grow
            rows="4"
            color="white"
            class="comment-area"
            :placeholder="$t('enter_your_comment')"
          />
        </div>
        <div class="col-12">
          <v-btn
            class="footer-text-btn"
            @click="confirm()"

          >
            {{ $t("ok") }}
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>
export default {
  name: "certificate-pin-modal",
  props: {
    dialog: Boolean,
    error: Boolean,
    errorMsg: String,
  },
  data: function() {
    return {
      commentText: "",
    };
  },
  computed: {
  overlayColor() {
        return this.$store.state.common.appBarColor;
    },
  },
  watch: {
    dialog() {
      if (this.dialog && !this.error) {
        this.commentText = "";
      }
    },
  },
  methods: {
    confirm() {
      console.log("Guardar comentarios:", this.commentText);
      this.$emit("submitComments", this.commentText);
      this.$emit("update:dialog", false); // 🔥 Cerrar el modal en el padre
    },
  },
};
</script>
